/**
 * Copyright 2022 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export class GraphQLError extends Error {
  readonly errors: { message: string }[] | undefined;
}
